import React, { FC } from 'react';
import styled from 'styled-components';
import Text from 'components/UI/Text';
import { Tooltip } from '@mui/material';
import { observer } from 'mobx-react';
import i18next from 'i18next';
import { IProtocol } from 'models/protocol';

const StyledTextVarietyText = styled(Text)`
  width: 100%;
`;

const CropVarietyBodyContainer: FC<{ data: IProtocol }> = observer(
  ({ data }) => {
    const { classification } = data;
    const fullText = classification.cropVariety
      ? classification.cropVariety.toString().replaceAll(',', ', ')
      : i18next.t('crop_models:not_available');

    return (
      <Tooltip arrow title={fullText} placement="top">
        <StyledTextVarietyText inline singleline size="md">
          {fullText}
        </StyledTextVarietyText>
      </Tooltip>
    );
  },
);

const CropVarietyBody = (props: IProtocol) => {
  return <CropVarietyBodyContainer data={props} />;
};

export default CropVarietyBody;
